import PropTypes from 'prop-types'
import Head from 'next/head'
import { SITE_NAME } from '~/lib/constants/company'

function Title ({ title }) {
  return (
    <Head>
      <title>{title ? `${title} | ` : ''}{SITE_NAME}</title>
    </Head>
  )
}

Title.propTypes = {
  title: PropTypes.string
}

export default Title
